import { render } from "./StatisticsCard.vue?vue&type=template&id=048815ed"
import script from "./StatisticsCard.vue?vue&type=script&lang=js"
export * from "./StatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__